import type { LOG_FLOODGATE_ACTIVITYActionMessage } from './actions/publicActions';
import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyAction, LazyModule } from 'owa-bundling';
import type { SurveyActivityType } from './schema/SurveyActivityType';

const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "FloodgateFeedback" */ './lazyIndex'),
    { name: 'FloodgateFeedback' }
);

export const lazyLoadAndInitializeFloodgateEngine: LazyAction<
    typeof lazyIndex.loadAndInitializeFloodgateEngine,
    LazyModule<typeof lazyIndex>
> = new LazyAction(lazyModule, m => m.loadAndInitializeFloodgateEngine);
export const lazyLogFloodgateActivity: LazyImport<
    (
        activityType: SurveyActivityType,
        searchTraceId?: string | null,
        isOpx?: boolean,
        autoDismissVal?: number,
        showEmailAddress?: boolean,
        shouldShowScreenshot?: boolean
    ) => LOG_FLOODGATE_ACTIVITYActionMessage,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.logFloodgateActivity);

export type { SurveyActivityType } from './schema/SurveyActivityType';
